import * as authSelectors from './auth/selectors';
import * as dsConfigSelectors from './dsconfig/selectors';
import * as templatesSelectors from './templates/selectors';
import * as parsedTreesSelectors from './parsedTrees/selectors'
import * as designsSelectors from './designs/selectors';
import * as foldersSelectors from './folders/selectors';
import * as userFilesSelectors from './userFiles/selectors';
import * as userConfigSelectors from './userConfig/selectors';
import * as storageSelectors from './storage/selectors';
import * as OpenSelectors from './openReducers/selectors';
import * as dealersSelectors from './dealers/selectors';
import * as brandsSelectors from './brands/selectors';
import * as brandsImagesSelectors from './brandsImages/selectors';
import * as userAccessSelectors from './userAccess/selectors';
import * as industriesSelectors from './industries/selectors'

export default {
  auth: authSelectors,
  dsConfig: dsConfigSelectors,
  templates: templatesSelectors,
  parsedTrees: parsedTreesSelectors,
  designs: designsSelectors,
  folders: foldersSelectors,
  userFiles: userFilesSelectors,
  userConfig: userConfigSelectors,
  storage: storageSelectors,
  open: OpenSelectors,
  dealers: dealersSelectors,
  brands: brandsSelectors,
  brandsImages: brandsImagesSelectors,
  userAccess: userAccessSelectors,
  industries: industriesSelectors
};